module.exports = __webpack_public_path__ + "static/media/readyship.1e7fe9eb.jpg";